import actionCreatorFactory from 'typescript-fsa';

/** アンケート情報 */
export interface IQuestionnaire {
	id: string;
	text: string;
	answerPeriod: string;
	iconClass: string;
	requiredFlg: boolean;
	expired: boolean;
	enqueteType: string;
}

const actionCreator = actionCreatorFactory();

/** アンケート一覧設定アクションクリエータ */
export const setItems = actionCreator<{
	items: IQuestionnaire[];
}>('SET_QUESTIONNAIRE_ITEMS');

/** アンケート一覧情報初期化アクションクリエータ */
export const clearQuestionnaireParams = actionCreator<{}>(
	'CLEAR_QUESTIONNAIRE_PARAMS'
);



// WEBPACK FOOTER //
// ./src/actions/questionnaireList.ts